<app-dropdown
	label="Deposit Holder"
	[skeletonLoading]="skeletonLoading"
	[labelOrientation]="orientation"
	[labelIcon]="AI_ICON"
	[labelToolTip]="(fieldMappings$ | async)?.depositHolder ? AI_TOOLTIP : ''"
	[labelIconClasses]="AI_CLASSES"
	[itemGroups]="depositHolderSelections"
	[ngModel]="depositHolderName$ | async"
	(onSelect)="onDepositHolderChange($event)"
	[testHook]="testHooks.DepositHolderDropdown"
></app-dropdown>
